export default __webpack_public_path__ + "static/media/home_back.32acd341.jpg";